import React from 'react';
import { NavLink } from 'react-router-dom';
import cl from './Cart.module.css';

const Cart = (props) => {
  const { cartItems, onAdd, onRemove } = props;
  const subTotalPrice = cartItems.reduce((a, c) => a + c.oldPrice * c.qty, 0);
  const totalPrice = cartItems.reduce(
    (a, c) => a + ((c.oldPrice * (100 - c.discount)) / 100) * c.qty,
    0
  );
  const discountPrice = subTotalPrice - totalPrice;
  return (
    <section className={cl.main_cart}>
      <div className={cl.cart_style}>
        <h2 className={cl.header}>Cart Items</h2>
        <div>
          {cartItems.length === 0 && (
            <div className={cl.header_empty}>Cart Is Empty</div>
          )}
          {cartItems.map((item) => (
            <div key={item.id} className={cl.row}>
              <div className={cl.row_img_container}>
                <img src={item.images ? item.images[0] : ""} alt="" />
              </div>

              <div className={cl.name}>
                <div
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <div className={cl.buttons}>
                    <button
                      style={{ color: "red" }}
                      onClick={() => onAdd(item)}
                      className={cl.add}
                    >
                      <svg
                        fill="#000000"
                        version="1.1"
                        id="Capa_1"
                        width="20px"
                        height="20px"
                        viewBox="0 0 45.402 45.402"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          {" "}
                          <g>
                            {" "}
                            <path d="M41.267,18.557H26.832V4.134C26.832,1.851,24.99,0,22.707,0c-2.283,0-4.124,1.851-4.124,4.135v14.432H4.141 c-2.283,0-4.139,1.851-4.138,4.135c-0.001,1.141,0.46,2.187,1.207,2.934c0.748,0.749,1.78,1.222,2.92,1.222h14.453V41.27 c0,1.142,0.453,2.176,1.201,2.922c0.748,0.748,1.777,1.211,2.919,1.211c2.282,0,4.129-1.851,4.129-4.133V26.857h14.435 c2.283,0,4.134-1.867,4.133-4.15C45.399,20.425,43.548,18.557,41.267,18.557z"></path>{" "}
                          </g>{" "}
                        </g>
                      </svg>
                    </button>
                    <button
                      onClick={() => onRemove(item)}
                      className={cl.remove}
                    >
                      <svg
                        width="20px"
                        height="20px"
                        viewBox="0 -12 32 32"
                        version="1.1"
                        
                       
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          {" "}
                          <title>minus</title>{" "}
                          <desc>Created with Sketch Beta.</desc> <defs> </defs>{" "}
                          <g
                            id="Page-1"
                            stroke="none"
                            strokeWidth="1"
                            fill="none"
                            fill-rule="evenodd"
                           
                          >
                            {" "}
                            <g
                              id="Icon-Set-Filled"
                              
                              transform="translate(-414.000000, -1049.000000)"
                              fill="#000000"
                            >
                              {" "}
                              <path
                                d="M442,1049 L418,1049 C415.791,1049 414,1050.79 414,1053 C414,1055.21 415.791,1057 418,1057 L442,1057 C444.209,1057 446,1055.21 446,1053 C446,1050.79 444.209,1049 442,1049"
                                id="minus"
                                
                              >
                                {" "}
                              </path>{" "}
                            </g>{" "}
                          </g>{" "}
                        </g>
                      </svg>
                    </button>
                  </div>

                  <div className={cl.amount}>
                    {item.qty} x $
                    {((item.oldPrice * (100 - item.discount)) / 100).toFixed(2)}
                  </div>
                </div>
                {item.name}
              </div>
            </div>
          ))}
        </div>
      </div>
      {cartItems.length !== 0 && (
        <>
          <div className={cl.cart_style}>
            <div>
              <div className={cl.price}>
                <div>Subtotal</div>
                <div>${subTotalPrice.toFixed(2)}</div>
              </div>
              <div className={cl.price}>
                <div>Discount</div>
                <div>-${discountPrice.toFixed(2)}</div>
              </div>
              <div className={cl.price_total}>
                <div>Total Price</div>
                <div>${totalPrice.toFixed(2)}</div>
              </div>
            </div>
            <NavLink className={cl.button_checkout} to="/checkout">
              CHECK OUT
            </NavLink>
          </div>
        </>
      )}
    </section>
  );
};

export default Cart;
